module.exports = {
	"de-tal": {
		"ui": {
			"project": {
				"standard_title": "Die Standard Talentmaske enthält:",
				"standard_subtitle_1": "Persönlich",
				"standard_subtitle_2": "Unternehmen",
				"standard_description_1": "Sprache, Geschlecht, Titel, Vorname, Nachname, E-Mail, Abteilung, Funktion, Rolle, Job",
				"standard_description_2": "Firmenname, Branche, Telefon, Webseite, Straße, Nummer, PLZ, Stadt, Land",
				"advanced_title": "Die erweiterte Talentmaske enthält die selben Tabs und Felder die auch die Standard Talentmaske enthält. Außerdem:",
				"advanced_subtitle_1": "Kampagnen Termin",
				"advanced_subtitle_2": "Qualifizierung",
				"advanced_description_1": "Kundenanfragen, Information, E-Mail Marketing (Newsletter, Event und E-Mail Abonnement)",
				"advanced_description_2": "Notizen, Interesse an, Kampagne geplant (Dauer in Monaten)",
				"create_leadsheet": "Erstelle eine neue Talentmaske"
			},
			"segments": {
				"segments": "Segmente",
				"is_editing_state": "Speichere das Segment bevor du fortfährst",
				"add_to_project": {
					"empty": "Keine Kampagnen",
					"success": "Ihre Kontakte werden der Kampagne hinzugefügt. Dies kann einige Minuten dauern.",
					"error": "Beim Hinzufügen von Kontakten zur Kampagne ist ein Fehler aufgetreten"
				},
				"columns": {
					"name": "Name",
					"id": "ID",
					"created": "Erstellt am",
					"updated": "Zuletzt aktualisiert",
					"creator": "Ersteller"
				},
				"actions": {
					"success": "Segment erfolgreich gespeichert!",
					"error": "Segment konnte nicht gespeichert werden.",
					"edit": "Editieren",
					"edit_description": "Editieren",
					"duplicate": "Duplizieren",
					"duplicate_description": "Duplizieren",
					"duplicate_name": "Kopie von {name}",
					"delete": "Löschen",
					"delete_description": "Löschen"
				},
				"business_kit": {
					"segment_title": "Senden an",
					"subtext": "Stellen Sie sicher, dass Ihr Talentkit korrekt eingerichtet ist, bevor Sie es versenden",
					"contacts": "Kontakte",
					"success": "Talentkit erfolgreich verschickt",
					"error": "Beim Talentkit-Verschicken ist ein Fehler aufgetreten",
					"preview": "Vorschau",
					"email_templates_confirmation": "Bestätigen Sie, dass es eine E-Mail-Vorlage für dieses Talentkit gibt. Wenn keine E-Mail-Vorlage erstellt wurde, wird dieses Talentkit nicht versendet."
				},
				"create_modal": {
					"title": "Segment erstellen",
					"field_label": "Neuer Segment Name",
					"duplicate": "Erstellen",
					"name": "Name"
				},
				"delete_modal": {
					"title": "Segment löschen"
				},
				"duplicate_modal": {
					"title": "Segment duplizieren",
					"duplicate": "Duplizieren",
					"name": "Neuer Segment Name"
				},
				"bbusinesskits_modal": {
					"title": "Bereit zum Versenden",
					"send": "Kit versenden"
				},
				"add_to_project_modal": {
					"title": "Zur Kampagne hinzufügen",
					"search_label": "Kampagne durchsuchen",
					"add_button": "Hinzufügen"
				},
				"export": {
					"success": "Export abgeschlossen. Sie sollten in Kürze eine E-Mail mit Ihren Kontakten erhalten.",
					"error": "Beim Exportieren ist ein Fehler aufgetreten, bitte versuchen Sie es erneut."
				},
				"delete": {
					"success": "Kontakte erfolgreich gelöscht",
					"error": "Einer oder mehrere Kontakte konnten nicht gelöscht werden."
				}
			},
			"segment": {
				"breadcrumb_back": "Alle Segmente"
			},
			"contacts": {
				"modals": {
					"delete": {
						"title": "Kontakte löschen"
					}
				},
				"title": "Kontakte",
				"create": "Kontakt erstellen",
				"empty_state_msg": "Keine Kontakte auf Basis der Filtereinstellungen gefunden",
				"columns": {
					"name": "Name",
					"id": "ID",
					"created": "Erstellt am",
					"updated": "Zuletzt aktualisiert",
					"company": "Firma",
					"source": "Quelle",
					"email": "E-Mail",
					"gender": "Geschlecht"
				},
				"actions": {
					"export": "Exportieren",
					"save_to_project": "Zur Kampagne hinzufügen",
					"send_businesskit": "Ein Businesskit verschicken",
					"delete": "Löschen",
					"error": "Es gab einen Fehler beim Aktualisieren des Kontakts",
					"success": "Der Kontakt wurde erfolgreich aktualisiert"
				},
				"filters": {
					"custom_placeholder": "Kampagnen Attribute...",
					"general": {
						"none": "Keine zugeordnet"
					},
					"project": {
						"label": "Kampagnen Name",
						"none": "Gehört zu keinen Kampagnen"
					},
					"company": {
						"label": "Firma",
						"none": "Gehört zu keinen Kampagnen"
					},
					"gender": {
						"label": "Geschlecht",
						"options": {
							"male": "Männlich",
							"female": "Weiblich"
						}
					},
					"language": {
						"label": "Sprache",
						"options": {
							"en": "Englisch",
							"de": "Deutsch"
						}
					},
					"invalid_email": {
						"label": "E-Mail ist gültig",
						"condition_label": "E-Mail",
						"options": {
							"valid": "Gültig",
							"not_valid": "Ungültig"
						}
					},
					"created": {
						"label": "Erstellt"
					},
					"updated": {
						"label": "Aktualisiert"
					},
					"city": {
						"label": "Stadt"
					},
					"country": {
						"label": "Land"
					},
					"tags": {
						"label": "Tags"
					}
				},
				"import": {
					"title": "Kontakte importierne",
					"description": "Laden Sie eine CSV-Datei mit den zu importierenden Kontakten hoch.",
					"format": "Die Datei sollte mindestens drei Spalten enthalten: Vorname, Nachname und E-Mail. Nur die E-Mail ist obligatorisch, aber Vorname und Nachname sind sehr empfehlenswert.",
					"success_flash": "Kontakte wurden erfolgreich importiert",
					"success_modal_title": "Import abgeschlossen",
					"success_modal_body": "Deine Kontakte wurden erfolgreich importiert.",
					"success_modal_report": "Von {total} importieren Kontaten wurden {new} erstellt und {updated} aktualisiert."
				}
			},
			"contact": {
				"edit": "Editieren",
				"change_company": "Änderung",
				"breadcrumb_back": "Alle Kontakte",
				"empty_state_text": "Dieser Kontakt wurde noch nicht als Lead erfasst.",
				"contact_details": "Kontakt Details",
				"company_details": "Firma Details",
				"created": "Erstellt am",
				"updated": "Aktualisiert am",
				"is_lead_on": "Ist Lead von",
				"go_to_lead": "Zum Lead",
				"tags": "Tags",
				"source": "Quelle",
				"sources": {
					"web_app": "Web App",
					"mobile_app": "Mobile App",
					"external_form": "Formular",
					"crm_sync": "CRM Sync",
					"upload": "Hochgeladen",
					"unknown": "Unbekannt"
				},
				"caption": {
					"email": "E-Mail",
					"firstname": "Vorname",
					"lastname": "Name",
					"business_card_job_title": "Job-Titel",
					"company_department": "Abteilung",
					"phone_mobile": "Mobiltelefon",
					"phone_company": "Firmen-Telefon",
					"phone_private": "Privates Telefon",
					"gender": "Anrede",
					"language": "Sprache"
				}
			},
			"xtable": {
				"toggle_columns": "Spalten bearbeiten",
				"actions": "Aktionen",
				"page_size_label": "Ansicht",
				"search_placeholder": "Suchen",
				"save_search_title": "Suche speichern",
				"save_search_label": "Name",
				"empty_state_label": "Keine Daten entsprechen den Filtern",
				"empty_cell_value": "Kein {name} zugeordnet"
			},
			"xfilters": {
				"confirm_removal": "Ja, Filter entfernen",
				"add_filter": "Filter hinzufügen",
				"add_filter_confirm": "Hinzufügen",
				"delete_filter_warning": "Sie sind dabei, eine Filterbedingung zu entfernen oder zu ersetzen, von der andere Bedingungen abhängen. Wenn Sie fortfahren, dann werden auch alle diese abhängigen Bedingungen entfernt.",
				"delete_filter_confirmation": "Sind Sie sicher, dass Sie weitermachen wollen?",
				"conditions": {
					"operators": {
						"and": "und",
						"or": "oder"
					},
					"predicates": {
						"has_any": "hat einen",
						"has_all": "hat alle"
					},
					"summary": {
						"is": "{0} ist {1}",
						"has_all": "{0} hat alle {1}",
						"has_any": "{0} hat einen von {1}",
						"includes": "{0} enthält {1}",
						"is_not_assigned": "{0} ist nicht zugeordnet",
						"date_on": "{0} am {1}",
						"date_between": "{0} zwischen {1} und {2}",
						"date_since": "{0} seit {1}",
						"date_before": "{0} am oder vor {1}",
						"date_in_range": "{1} {0}",
						"date_in_range_simple": "{1} {0}"
					}
				},
				"xfiltermodal": {
					"date_from": "Von",
					"date_to": "Bis"
				},
				"date_ranges": {
					"custom": "Angepasste",
					"today": "Heute",
					"yesterday": "Gestern",
					"past_week": "Letzte Woche",
					"past_month": "Letzten Monat",
					"past_year": "Letztes Jahr"
				}
			},
			"drag_elements": {
				"gender": "Geschlecht/Anrede",
				"paragraph": "Paragraph",
				"title": "Titel",
				"confirmation": "Bestätigung",
				"firstname": "Vorname",
				"lastname": "Nachname",
				"email": "E-Mail",
				"company": "Unternehmen",
				"street": "Straße",
				"street_number": "Hausnummer",
				"zip": "PLZ",
				"city": "Stadt",
				"country": "Land",
				"website": "Webseite",
				"phone_company": "Telefon (Firma)",
				"phone_mobile": "Telefon (Mobil)",
				"textfield": "Textfeld",
				"long_textfield": "Langes Textfeld",
				"multi_select": "Mehrfachauswahl",
				"dropdown": "Dropdown",
				"single_select": "Einfachauswahl",
				"date": "Datum",
				"readonly": "Schreibgeschützt",
				"quantity_selection": "Mengenauswahl",
				"drawing": "Zeichnung"
			},
			"breadcrump": {
				"back": "Zurück",
				"all_projects": "Alle Kampagnen"
			},
			"dashboard": {
				"filter": {
					"all_projects": "Alle Kampagnen"
				},
				"leads_collected_label": "Erfasste Talente",
				"most_active_projects": "Aktivste Kampagnen",
				"leads_over_time": {
					"label": "Talente gesamt",
					"linear": "Talente",
					"cumulated": "Kumuliert"
				},
				"hot": "Heiß",
				"warm": "Warm",
				"cold": "Kalt",
				"unclassified": "Nicht klassifiziert",
				"top_projects_label": "Top Kampagnen",
				"kit_activity_label": "Letzte Interaktionen",
				"latest_activity_label": "Letzte Aktivität",
				"leads_by_project_label": "Talente in Kampagnen",
				"leads_by_most_active_projects_label": "Talente in den aktivsten Kampagnen",
				"leads_by_most_active_projects": {
					"me": "Meine",
					"org": "Org"
				},
				"empty_state_headline": "Das Dashboard wird angezeigt sobald genügend Daten zur Verfügung stehen",
				"empty_state_intro": "Erstellen Sie Ihre ersten Inhalte",
				"empty_state_cta": "Kampagne erstellen",
				"top_sources_label": "Top Quellen",
				"active_leads": {
					"label": "Aktivste Talente",
					"today": "Heute",
					"last_7": "Letzte 7 Tage",
					"last_month": "Letzten Monat",
					"last_year": "Letztes Jahr",
					"all_time": "Gesamt"
				},
				"leads_over_time_label": "Talente gesamt",
				"axischart": {
					"last_week": "Letzte Woche",
					"last_month": "Letzten Monat",
					"last_year": "Letztes Jahr"
				},
				"top_projects": {
					"kits": "Kits",
					"leads": "Talente",
					"my_leads": "Meine Talente",
					"lead_sheet": "Talentmaske"
				},
				"top_sources": {
					"last_week": "Letzte Woche",
					"last_month": "Letzten Monat",
					"last_year": "Letztes Jahr",
					"web_app": "Web app",
					"external_forms": "Formulare",
					"mobile_app": "Mobil"
				},
				"kit_activity": {
					"all": "Alle",
					"opened_kit": "Öffnete",
					"updated_a_lead": "hat ein Talent aktualisiert",
					"empty_state_headline": "Noch keine Businesskit Aktivität",
					"empty_state_intro": "Erstellen Sie ansprechende und personalisierte Inhalte, die Ihnen helfen, sich wirklich mit Ihrem Unternehmen zu verbinden.",
					"interacted_with": "Interagierte mit",
					"view_content_card": "Hat eine Content-Card angeschaut | Hat {count} Content-Cards angeschaut",
					"click_content_card": "Klickte auf einen Call-to-Action | Klickte auf {count} Call-to-Actions"
				},
				"latest_activity": {
					"label": "Neuste Talente",
					"edited_in": "Bearbeitet in",
					"added_to": "Hinzugefügt zu",
					"by": "Von",
					"incomplete_lead": "Unvollständiges Talent"
				},
				"conversion_funnel": {
					"label": "Conversion Funnel",
					"cumulative_conversion": "Kumulative Umwandlung",
					"leads": "Talente",
					"sendouts": "Sendouts",
					"visits": "Öffnungen",
					"interactions": "Interaktionen"
				},
				"activity_list_widget": {
					"created_a_lead": "hat ein Talent erstellt",
					"updated_a_lead": "hat ein Talent aktualisiert",
					"on": "am",
					"latest_activity": "Letzte Aktivität",
					"empty_state_headline": "Noch keine Aktivität",
					"empty_state_intro": "Kampagne erstellen"
				}
			},
			"email_template": {
				"placeholders": {
					"firstname": "Firstname",
					"lastname": "Last name",
					"formal": "Formal salutation",
					"informal": "Informal salutation",
					"gender": "Mr/Mrs",
					"form_title": "Formular Titel"
				}
			},
			"meta_info": {
				"invitation": "Willkommen zu Talent",
				"reset_password": "Passwort zurücksetzen"
			},
			"auth": {
				"button": "Anmelden",
				"confirm": "Passwort setzen",
				"create_account_subtitle": "Wähle ein Passwort",
				"create_account_subtitle_confirm": "Du hast Deinen Account erfolgreich erstellt. Bitte melde Dich nun bei Talent an.",
				"create_account_title": "Erstelle Deinen Account",
				"create_account_title_confirm": "Glückwunsch",
				"email": "E-Mail Adresse",
				"firstname": "Vorname",
				"go_to_login": "Zum Login",
				"password": "Passwort",
				"password_confirmation": "Passwort bestätigen",
				"password_reset": "Passwort vergessen?",
				"password_reset_request_title": "Setze Dein Passwort zurück",
				"password_reset_request_title_confirm": "Schau in Dein E-Mail Postfach",
				"password_reset_sent": "Eine E-Mail mit weiteren Anweisungen, wie Du Dein Passwort zurücksetzen kannst, wurde geschickt.",
				"password_reset_title": "Passwort zurücksetzen",
				"password_reset_title_confirm": "Glückwunsch",
				"lastname": "Nachname",
				"return_to_login": "Zurück zum Login",
				"success": "Dein Passwort wurde erfolgreich gesetzt. Du kannst dich nun in alle Fanomena Talent Produkte einloggen.",
				"user_not_found": "Benutzer nicht gefunden",
				"user_not_found_subtitle": "Es tut uns Leid aber wir konnten diesen Benutzer nicht finden.<br/>Vermutlich ist Ihr Einladungs-Link abgelaufen oder der Benutzer wurde gelöscht."
			},
			"auth_illustration": {
				"contact_us": "Kontaktiere uns",
				"get_access": "Erhalte Deinen Zugang",
				"invitation_subtitle": "Entdecke Deine Möglichkeiten",
				"invitation_title": "Möchtest Du mehr über Fanomena Talent erfahren?",
				"login_subtitle": "Wir zeigen Dir Fanomena Talent",
				"login_title": "Neu hier und willst Du Dich umsehen?",
				"reset_request_subtitle": "Wir helfen Dir",
				"reset_request_title": "Keine Möglichkeit zurückzusetzen?",
				"reset_subtitle": "Wir helfen Dir",
				"reset_title": "Keine Möglichkeit zurückzusetzen?"
			},
			"business_kit": {
				"preview": "Vorschau Talentkit",
				"confirmation": "Hiermit wird bestätigt, dass Informationsmaterial angefordert und verschickt werden darf.",
				"history": "Talentkits verschickt",
				"send": "Ein Talentkit verschicken",
				"send_confirm": "Talentkit senden"
			},
			"button": {
				"double_optin": "Sicher?",
				"external_forms": {
					"new": "Formular hinzufügen"
				},
				"contacts": {
					"create": "Kontakt erstellen",
					"import": "Importieren",
					"save_as_segment": "Als Segment speichern"
				},
				"segments": {
					"new": "Segment erstellen",
					"save": "Segment speichern"
				},
				"external_form": {
					"add_popup": "Formular erstellen",
					"save": "Speichern",
					"publish": "Veröffentlichen"
				},
				"lead_mask": {
					"save": "Speichern",
					"publish": "Veröffentlichen"
				},
				"lead_masks": {
					"add_popup": "Talentmaske hinzufügen"
				},
				"opt-ins": {
					"new": "Opt-In hinzufügen"
				},
				"organizations": {
					"new": "Neue Organisation hinzufügen"
				},
				"project_leads": {
					"add_popup": "Talent hinzufügen",
					"confirm_mail": "E-Mail Adresse bestätigen",
					"confirm_picture": "Speichern & weiter",
					"continue": "Neues Unternehmen",
					"create": "Talent erfassen",
					"export": "XLS exportieren",
					"make_another_picture": "Wiederholen",
					"new": "Talent hinzufügen",
					"take_picture": "Visitenkarte aufnehmen"
				},
				"projects": {
					"new": "Kampagnen erstellen"
				},
				"users": {
					"new": "Benutzer hinzufügen",
					"invite": "Einladen",
					"invite_xls": "Via XLS einladen",
					"upload_xls": "Weiter"
				},
				"email_templates": {
					"new": "Template hinzufügen"
				},
				"workflows": {
					"new": "Neuer Workflow erstellen",
					"trigger": "Workflow ausführen"
				}
			},
			"filters": {
				"apply": "Anwenden",
				"import_origin": "Importquelle",
				"origin": "Talentquelle",
				"start_date": "Erstellung",
				"sync_disabled": "CRM Sync",
				"sync_status": "Sync Status",
				"hint": "Suchergebnisse filtern",
				"reset": "Zurücksetzen",
				"categories": "Kategorien"
			},
			"footer": {
				"imprint": "Impressum",
				"privacy": "Datenschutz",
				"terms": "Geschäftsbedingungen",
				"security": "Sicherheit"
			},
			"onboarding": {
				"next": "Weiter",
				"skip": "Überspringen",
				"start": "Starten",
				"step1": {
					"title": "Kampagne erstellen",
					"subtitle": "Erstellen Sie mit nur wenigen Klicks Ihr erstes Kampagne und digitalisieren Sie Ihre Veranstaltungen und Marketing Kampagnen."
				},
				"step2": {
					"title": "Talent erfassen",
					"subtitle": "Erstellen und verbinden Sie die anpassbaren Formulare mit Ihrer nächsten digitalen Talent-Acquisitions Kampagne."
				},
				"step3": {
					"title": "Inhalte erstellen",
					"subtitle": "Erstellen und teilen Sie personalisierte Inhalte mit Ihren Talents, um diese zu qualifizieren und so mehr Kunden zu generieren."
				}
			},
			"content_manager": {
				"first-card": {
					"title": "Talentkits",
					"subtitle": "Erstellen Sie einzigartige und personalisierte Inhalte, mit denen Sie aus der Masse herausstechen und Ihre Interaktionsrate steigern.",
					"btn": "Talentkit erstellen"
				},
				"second-card": {
					"title": "Formulare",
					"subtitle": "Erstellen Sie Fanomena Talent Formulare, die Sie ganz einfach in Ihrer Website einbinden können. Integrieren Sie gleichzeitig Ihre Marketing Tools (Webinar Tools, CRM) und automatisieren Sie Folgeprozesse.",
					"btn": "Formulare erstellen"
				},
				"third-card": {
					"title": "Talentmasken",
					"subtitle": "Erstellen Sie individuelle Talentmasken und fragen Sie alle Informationen ab, die Sie für Ihren Qualifizierungsprozess benötigen.",
					"btn": "Support kontaktieren"
				}
			},
			"empty_state": {
				"projects": {
					"title": "Neue Kampagne starten",
					"title-standard-user": "Willkommen bei Talents",
					"subtitle": "Digitalisieren Sie Ihren Talent Acquistion Prozess und analysieren Sie alle Daten an einem Ort",
					"standard-user": "Bislang wurden Sie zu keinem Kampagne hinzugefügt. Bitte kontaktieren Sie Ihren Administrator, um mit der Bearbeitung starten zu können."
				},
				"leads": {
					"title": "Erfassen Sie Ihren ersten Kandidaten in der Kampagne.",
					"subtitle": "Bislang wurden Sie zu keinem Kampagne hinzugefügt. Bitte kontaktieren Sie Ihren Administrator, um mit der Bearbeitung starten zu können."
				}
			},
			"taglist": {
				"label": "Art des Kampagnees"
			},
			"global": {
				"assign": "Zuordnen",
				"back": "Zurück",
				"cancel": "Abbrechen",
				"confirm": "Bestätigen",
				"continue": "Weiter",
				"delete": "Löschen",
				"delete_confirmation": "Bist Du sicher dass Du {name} löschen willst?",
				"delete_title": "Wirklich löschen?",
				"edit": "Editieren",
				"empty_collection": "Es gibt noch keine Einträge",
				"no_results": "Leider keine Ergebnisse.",
				"no": "Nein",
				"save": "Speichern",
				"show": "Anzeigen",
				"take_picture": "Foto aufnehmen",
				"unassign": "Entfernen",
				"valid": "Bestätigen",
				"yes": "Ja",
				"back_to_home": "Zurück zur Homepage",
				"lead_edit_abort": "Willst Du wirklich zurück? Es gibt ungespeicherte Änderungen.",
				"date_time": {
					"today": "heute",
					"yesterday": "gestern",
					"seconds_ago": "vor ein paar Sekunden",
					"less_than_minute": "vor weniger als einer Minute",
					"minutes_ago": "vor ein paar Minuten",
					"now": "jetzt",
					"at": "um"
				}
			},
			"header": {
				"add-lead": "Talent hinzufügen",
				"add-project": "Kampagne hinzufügen"
			},
			"language": {
				"change": "Sprache ändern:",
				"de-tal": "DE",
				"en-tal": "EN /"
			},
			"menu": {
				"project_assignments_edit": "Zuweisungen",
				"businesskits": "Talentkits",
				"plans": "Plans",
				"change-language": "Ändere Sprache zu Englisch",
				"profile": "Profil",
				"business_kits": "Alle Talentkits",
				"dashboard": "Dashboard",
				"external_forms": "Formulare",
				"external_form_editor": "Editor",
				"external_form_options": "Optionen",
				"external_form_preview": "Vorschau",
				"general_settings": "Allgemeine Einstellungen",
				"lead_masks": "Talentmasken",
				"lead_mask_editor": "Editor",
				"lead_mask_options": "Optionen",
				"logout": "Abmelden",
				"manage_projects": "Kampagnen verwalten",
				"organizations": "Organisationen",
				"project_edit": "Einstellungen",
				"project_leads": "Talente",
				"project_statistics": "Statistiken",
				"projects": "Kampagnen",
				"projects_synchronize": "Sync mit CRM",
				"settings": "Benutzer verwalten",
				"statistics": "Statistiken",
				"trackings": "Trackings",
				"user_profile": "Profileinstellungen",
				"users": "Benutzer",
				"email_templates": "E-Mail Templates",
				"content_manager": "Manage",
				"contact_manager": "Kontaktmanager",
				"contacts": "Kontakte",
				"companies": "Unternehmen",
				"segments": "Segmente",
				"sync": "Sync",
				"workflows": "Workflows",
				"people": "Kontakte",
				"menu_tab_lead_capture": "Talenterfassung",
				"menu_tab_settings": "Einstellungen"
			},
			"pages": {
				"businesskits": "Alle Talentkits",
				"contact_us": "Kontaktiere uns",
				"contact_us_email": "mailto:talent@fanomena.io?subject=Account%20wiederherstellen&body=Liebes%20Fanomena%20Team%2C%0A%0ALeider%20kann%20ich%20mich%20weder%20zu%20meinen%20Account%20anmelden%20noch%20mein%20Passwort%20erfolgreich%20zur%C3%BCcksetzen.%20K%C3%B6nnt%20ihr%20mir%20bitte%20helfen%3F%0A%0ADanke%2C",
				"external-forms": "Formulare",
				"external-forms--button": "Ein Formular hinzufügen",
				"external-forms-create-button": "Formular erstellen",
				"external-forms-update-button": "Formular editieren",
				"get_your_access": "Zugang erhalten",
				"item-create": "Erstellen",
				"item-new": "Neu",
				"item-update": "Editiere {name}",
				"lead-create": "Talente zur Kampagne hinzufügen",
				"lead-edit": "Editiere ein Talent",
				"lead-mask-create-button": "Talentmaske aktualisieren",
				"lead-mask-edit": "Editiere {name}",
				"lead-mask-update-button": "Talentmaske aktualisieren",
				"lead-masks": "Talentmaske",
				"lead-no-businesskit": "Diesem Kampagne ist noch kein Talentkit zugewiesen.",
				"lead-statistics": "Talent-Statistiken",
				"lead-statistics-overview": "Übersicht",
				"lead-statistics-trackings": "Trackings",
				"lead-change-count": "{num} Änderung durchgeführt | {num} Änderungen durchgeführt",
				"login": "Willkommen",
				"login_details": "Trage Deine Details ein um fortzufahren",
				"logout": "Danke",
				"logout_details": "dass Du Fanomena Talent benutzt hast. Bis bald!",
				"opt-ins": "Alle Opt-Ins",
				"organization-edit": "Editiere {name}",
				"organization-edit-button": "Organisation aktualisieren",
				"organization-new": "Organisation erstellen",
				"organization-new-button": "Organisation erstellen",
				"organization-create-button": "Organisation erstellen",
				"organization-update-button": "Organisation aktualisieren",
				"organizations": "Alle Organisationen",
				"password_reset": "Trage hier ein neues Passwort ein",
				"password_reset_confirm": "Dein Passwort wurde erfolgreich zurückgesetzt",
				"password_reset_request": "Trage Deine E-Mail Adresse ein und wir senden Dir einen Link, mit dem Du Dein Passwort wiederherstellen kannst.",
				"password_reset_request_confirm": "Eine E-Mail mit einem Passwort-Zurücksetzen-Link wurde an die E-Mail Adresse geschickt sofern sie existiert.",
				"project-assign": "Zum Kampagne hinzufügen",
				"project-create": "Neues Kampagne hinzufügen",
				"project-create-button": "Kampagnen erstellen",
				"project-download-data": "Daten als XLS herunterladen",
				"project-download-data-suceed": "Die XLS-Datei wurde an Deine E-Mail Adresse geschickt",
				"project-edit": "Editiere {name}",
				"project-options": "Kampagne Optionen",
				"project-show": "{name}",
				"project-update-button": "Speichern",
				"projects": "Kampagnen",
				"statistic-show": "Statistik Details: {name}",
				"statistics": "Statistiken",
				"take_a_tour": "Zur Webseite",
				"user-edit": "Editiere {name}",
				"user-edit-button": "Benutzer aktualisieren",
				"user-new-button": "Benutzer hinzufügen",
				"user-show": "Benutzer: {name}",
				"user-update-button": "Benutzer aktualisieren",
				"users": "Benutzer",
				"email-templates": "E-Mail Templates",
				"email-templates-update": "Template editieren",
				"email-templates-create": "Template erstellen",
				"email-templates-new": "Erstelle ein Template",
				"email-templates-update-button": "Template editieren",
				"email-templates-create-button": "Erstelle Template",
				"email-templates-new-button": "Erstelle ein Template",
				"project-assign-businesskit": "Talentkits zuweisen",
				"project-assign-user": "Benutzer zuweisen",
				"project-assigned-businesskit": "Talentkits",
				"project-assigned-user": "Benutzer",
				"project-assignments": "Kampagne Zuweisungen",
				"project-edit-user": "Editieren",
				"user-invite": "Benutzer einladen",
				"project-next-button": "Weiter",
				"project-capture-leads": "Zum Kampagne",
				"project-view-talentkit": "Talentkit zuweisen",
				"project-create-talentkit": "Talentkit zuweisen",
				"project-create-content": "Inhalte erstellen",
				"previous": "Zurück",
				"workflow-update-button": "Workflow aktualisieren",
				"workflows": "Workflows",
				"contacts": "Alle Kontakte",
				"companies": "Unternehmen",
				"segments": "Alle Segmente"
			},
			"project_wizard": {
				"step1-title": "Kampagne anlegen",
				"step2-title": "Talentkit wählen",
				"step2-invite-users": "Lade neue Benutzer zu Fanomena Talent ein",
				"step2-assign-users": "Füge einen weiteren Benutzer zu diesem Kampagne hinzu",
				"businesskits": "Jede Kampagne ist mit einem Talentkit verknüpft.",
				"lead-sheets": "Talentmasken",
				"leadsheet-create": "Individuelle Talentkit erstellen",
				"leadsheet-create-tip": "Bitte nehmen Sie Kontakt mit uns auf, wenn Sie eine individuelle Talentmaske erstellen möchten.",
				"leadsheet-basic": "Digitale Talentmaske zur Erfassung von personenbezogenen und geschäftlichen Daten.",
				"leadsheet-advanced": "Digitale Talentmaske, die alle Elemente der Standard Talentmaske und zusätzliche Fragen zur Qualifizierung Ihrer Talente enthält.",
				"success-title": "Herzlichen Glückwunsch. Sie haben Ihr Kampagne erfolgreich erstellt.",
				"success-subtitle": "Wie möchten Sie fortfahren?",
				"step2-invite": "Um bestehende Talent Benutzer diesem Kampagne zuzuordnen, gehen Sie nach der Erstellung Ihrer Kampagne zu den Kampagneneinstellungen."
			},
			"searchbar": {
				"placeholder": {
					"bk": "Trag einen Talentkit Namen ein…",
					"email_templates": "Trag einen Namen ein…",
					"external_forms": "Trag einen Namen oder Kampagne ein…",
					"lead_masks": "Trag einen Namen ein…",
					"organizations": "Trag einen Namen ein…",
					"projects": "Suche nach einer Kampagne…",
					"project_leads": "Suche nach Talenten…",
					"users": "Trag einen Vornamen, Nachnamen oder E-Mail ein…"
				}
			},
			"tabs": {
				"company_tab": "Firmendaten",
				"kits_tab": "Kits",
				"personal_tab": "Persönlich",
				"qualify_tab": "Qualifikation",
				"stats_tab": "Stats"
			},
			"external_form": {
				"preview_page": {
					"title": "Einbetten",
					"head_paragraph": "Um das Formular auf Ihrer Webseite einzubinden, laden Sie bitte folgenden Script in Ihren <head>-Tag.",
					"html_paragraph": "Binden Sie danach das Formular via html-Tag dort ein, wo Sie es auf Ihrer Seite anzeigen wollen.",
					"script_paragraph": "Laden Sie danach das Formular via Javascript.",
					"head_section_title": "Head",
					"html_section_title": "HTML",
					"script_section_title": "Script",
					"forms_cannot_be_submitted": "Formulare können in der Vorschau nicht abgesendet werden. Das Aussehen des Formulars kann über die Webseite auf der es eingebettet wird individuell gesteuert werden."
				},
				"follow_up": "Folgeaktionen",
				"tabs": {
					"general": "Allgemein",
					"config": "Konfiguration",
					"editor": "Editor",
					"preview": "Vorschau"
				},
				"basic_config": "Grundeinstellungen",
				"form_editor": "Formular Editor",
				"frontend_actions": "Aktion wenn der Besucher das Formular abschickt:",
				"backend_actions": "Follow up Aktionen:",
				"bk_boarding": "Talentkit Boarding",
				"send_directly": "Verschicke das Talentkit manuell?",
				"email_notification": "E-Mail Benachrichtigung",
				"add_to_mailchimp": "Zu Mailchimp Liste hinzufügen",
				"field_assignation": "Felder-Zuweisungen Mailchimp",
				"board_bk": "Talentkit Boarding",
				"success_message": "Erfolgs-Nachricht:",
				"redirection_url": "Weiterleiten zu URL:",
				"send_notification_to": "Verschicke Benachrichtung an E-mail Adressen:",
				"mailchimp_list_id": "Mailchimp Listen ID",
				"board_citrix": "Citrix Boarding",
				"citrix_keys": "Citrix Webinar Keys",
				"send_lead_confirmation_mail": "Verschicke Benachrichtigung an Talent",
				"email_template": "E-Mail Template",
				"mail_subject": "E-Mail Betreff",
				"mail_url": "CTA URL",
				"mail_cta": "CTA Text"
			},
			"lead_mask_editor": {
				"see_raw": "Talentmask Original Content",
				"edit_element": "Element editieren",
				"delete_element": "Element löschen",
				"cancel": "Abbrechen",
				"valid": "Bestätigen",
				"chose_element": "Wähle ein Element",
				"name": "Name",
				"type": "Typ",
				"default_value": "Standardwert",
				"default_field": "Standardfeld",
				"element_width": "Element Breite",
				"required": "Pflichtfeld",
				"class": "Klasse",
				"label": "Label",
				"placeholder": "Platzhalter",
				"children": "Children",
				"displayed_name": "Angezeigt",
				"value": "Wert",
				"add_line": "Hinzufügen",
				"collection": "Collection",
				"delete": "Löschen",
				"set_default_value": "Als Standard setzen",
				"basic_config": "Grundeinstellungen"
			},
			"organizations": {
				"api": "Externe Anbindungen",
				"configuration": "Konfiguration",
				"general_settings": "Allgemeine Einstellungen"
			},
			"upload": {
				"dropzone_message": "Dateien hineinziehen oder zum Hochladen Klicken",
				"empty_file": "Datei entfernen"
			},
			"users": {
				"invite": "Benutzer einladen",
				"invite_xls_success": "Benutzer wurden erfolgreich hinzugefügt",
				"xls_invite": "Via XLS einladen",
				"xls_invite_description": "Du kannst eine XLS Datei mit den Benutzern die Du einladen willst bereitstellen. Diese werden dann eine Einladungs-E-Mail erhalten.",
				"xls_invite_format": "Die XLS Datei sollte drei Spalten beinhalten: firstname, lastname und email. Nur das E-Mail Feld ist Pflicht aber firstname und lastname sind empfohlen."
			},
			"integrations": {
				"go-to-webinar": "Füge automatisch alle Talent, die dein Formular ausfüllen, zu einem Webinar hinzu."
			},
			"modals": {
				"businesskit_assignment": {
					"title": "Talentkits verwalten",
					"subtitle": "Wählen Sie die Talentktis aus, die Sie der aktuellen Kampagne zuordnen möchte"
				},
				"user_assignment": {
					"title": "Benutzer verwalten",
					"subtitle": "Wählen Sie die Benutzer aus, die Sie der aktuellen Kampagne zuordnen möchten."
				},
				"workflow": {
					"create": {
						"title": "Erstellen eines Workflow"
					}
				},
				"warning": {
					"button": "Ich verstehe"
				}
			},
			"drag_editor": {
				"extra_values": "und {num} extra.",
				"unpublished_changes": "Es gibt unveröffentlichte Änderungen",
				"popup": {
					"unsaved_changes": "Du hast nicht gespeicherte Änderungen. Möchten Sie die Seite wirklich verlassen?"
				},
				"active_item": {
					"edit": "Ausgewähltes Element bearbeiten",
					"label": "Etikett",
					"value": "Wert"
				},
				"fields": {
					"add_item": "Eintrag hinzufügen",
					"label": "Etikett",
					"text": "Text",
					"placeholder": "Platzhaltertext",
					"required": "Dieses Feld muss ausgefüllt werden",
					"hidden": "Dieses Feld ausblenden",
					"class": "CSS-Klasse",
					"default_value": "Vorauswahl",
					"default_value_options": "Standardwert",
					"validation": "Fehlermeldung",
					"internal_name": "Interner Name",
					"show_as_buttons": "Stelle Elemente als Buttons dar",
					"enrich_tags": "Speichere Selektierung als Tags",
					"data_type": "Datentyp",
					"data_types": {
						"text": "Text",
						"number": "Nummer",
						"email": "E-Mail",
						"tel": "Telefonnummer",
						"url": "Url"
					}
				},
				"dragElements": {
					"generic": "Allgemeine Felder",
					"leadMask": "Talentmasken Felder",
					"basic": "Basic Elemente",
					"fields": "Felder",
					"advanced": "Erweiterte Felder",
					"standard": "Standard Felder"
				},
				"badges": {
					"hidden": "Verstecktes Feld"
				},
				"placeholders": {
					"anchor": "Link",
					"bold": "Fett",
					"italic": "Kursiv",
					"underline": "Unterstrichen"
				},
				"screenTooSmall": {
					"title": "Es tut uns Leid!",
					"subtitle": "Um unseren Editor effizient zu nutzen müssen Sie eine höhere Auflösung auf Ihrem Bildschirm einstellen."
				}
			}
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./hileadzz_i18n/talents/ui.de-tal.yml
// module id = 2042
// module chunks = 0